import { variableType_AttributeInstance } from '@app/hcs-shared';
import { ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
//################################# Get Actual Value #################################
const provideInfo_GetActualValue_Attribute = (data, variable) => {
    const parentId = variable.parents.variableId;
    const parentFinding = data.findings.item.toCreate?.find(i => i.variableId === parentId)
        ?? data.findings.item.toUpdate?.find(i => i.variableId === parentId);
    if (parentFinding?.type !== 'enumerated')
        return;
    const attribute = parentFinding.attributes?.find(att => att.variableId === variable._id);
    return attribute?.valueIds?.[0];
};
const provideInfo_GetActualValue_Regular = (data, variableId) => {
    const finding = data.findings.item.toCreate?.find(i => i.variableId === variableId)
        ?? data.findings.item.toUpdate?.find(i => i.variableId === variableId);
    if (finding?.isPartialCalculation)
        return;
    switch (finding?.type) {
        case 'enumerated':
            return finding.valueIds?.[0];
        case 'numeric':
            return finding.value;
    }
};
export const provideInfo_GetActualValue = (data, variableId) => {
    const variable = ModuleFE_Advisor_Variable.cache.unique(variableId);
    if (!variable)
        return;
    if (variable.type === variableType_AttributeInstance)
        return provideInfo_GetActualValue_Attribute(data, variable);
    return provideInfo_GetActualValue_Regular(data, variableId);
};
//################################# Get Suggested Value #################################
const provideInfo_GetSuggestedValue_Attribute = (suggestedFinding, variable) => {
    if (suggestedFinding.finding.type !== 'enumerated' || !suggestedFinding.finding.attributes?.length)
        return;
    const suggestedAtt = suggestedFinding.finding.attributes.find(i => i.variableId === variable._id);
    return suggestedAtt?.valueIds?.[0];
};
const provideInfo_GetSuggestedValue_Regular = (suggestedFinding) => {
    switch (suggestedFinding.finding.type) {
        case 'enumerated':
            return suggestedFinding.finding.valueIds?.[0];
        case 'numeric':
            return suggestedFinding.finding.value;
    }
};
export const provideInfo_GetSuggestedValue = (data, variableId) => {
    const variable = ModuleFE_Advisor_Variable.cache.unique(variableId);
    if (!variable)
        return;
    const prf = data.findings.item.toCreate?.find(i => i.variableId === variableId);
    //If no suggested finding, or the user has already interacted / rejected it, return nothing.
    if (!prf?.suggestedFinding || prf.suggestedFinding.userInteracted || prf.suggestedFinding.explicitReject)
        return;
    if (variable.type === variableType_AttributeInstance)
        return provideInfo_GetSuggestedValue_Attribute(prf.suggestedFinding, variable);
    return provideInfo_GetSuggestedValue_Regular(prf.suggestedFinding);
};
//################################# Get Partial Value #################################
export const provideInfo_GetPartialValue = (data) => {
    const partialFinding = data.partialCalculationFindings.find(i => i.variableId === data.input.varId);
    return partialFinding?.type === 'numeric' ? partialFinding.value : undefined;
};
//# sourceMappingURL=utils.js.map